module.exports = __webpack_public_path__ + "media/images/signal-strength-100-432240c6e831c0406160c834b3a2313c.svg";